.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

#firewall-advanced-rules-grid-form-field {
  margin-top: calc(var(--spacer)* -5); // remove extra space added by grid
}

#broken-firewall-rule-warning {
  padding: 0;
  margin: 16px 0;
}
